import { Component, Input, OnInit } from '@angular/core';
import { IOrderLine } from '@cakeiteasy/web-utils';
import { CART_LINE_TYPES } from '../../../cart';

@Component({
  standalone: false,
  selector: 'extra-product-tbody, tbody[extra-product-tbody]',
  templateUrl: './extra-product-tbody.component.html',
  styleUrls: ['./extra-product-tbody.component.scss']
})
export class ExtraProductTbodyComponent implements OnInit {
  @Input() orderLine: IOrderLine;
  @Input() currency: string;
  @Input() simplifyView = false;

  public CART_LINE_TYPES = CART_LINE_TYPES;
  public isValignBottom: boolean;
  public isValignTop: boolean;
  public isGreetingCardValign: boolean;

  public price: number;
  public total: number;

  ngOnInit(): void {
    this.isValignBottom = this.orderLine.type !== CART_LINE_TYPES.PICTURE
      && this.orderLine.type !== CART_LINE_TYPES.GREETING_CARD;

    this.isValignTop = this.orderLine.type === CART_LINE_TYPES.PICTURE;
    this.isGreetingCardValign = this.orderLine.type === CART_LINE_TYPES.GREETING_CARD;

    this.price = this.orderLine.price + this.orderLine.discountAmount;
    this.total = this.price * this.orderLine.quantity;
  }
}
